import { Back, gsap } from "gsap";
import { useRef } from "react";

const ExpandedNavigation = ({ refer }) => {
  const tl = useRef(gsap.timeline());

  const navigateToSection = (e) => {
    if (e.target.parentElement === e.currentTarget)
      tl.current
        .to(window, {
          scrollTo: {
            y: `.${e.target.innerText}`,
            offsetY: centerOffset(`.${e.target.innerText}`),
          },
          duration: 1.2,
          ease: Back.easeOut.config(0.8),
        })
        .to(
          "body",
          {
            pointerEvents: "none",
          },
          "<"
        )
        .to("body", {
          pointerEvents: "auto",
        });
  };

  const centerOffset = (element) => {
    return (
      (window.innerHeight - document.querySelector(element).clientHeight) / 2
    );
  };

  return (
    <div
      className="exp-nav-common exp-nav-horizontal"
      ref={refer}
      onClick={navigateToSection}
    >
      <h3>about</h3>
      <h3>work</h3>
      <h3>contact</h3>
    </div>
  );
};

export default ExpandedNavigation;
